import React, { useEffect, useRef } from 'react';
import './HeroScene3D.css';

const HeroScene3D: React.FC = () => {
  const sceneRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scene = sceneRef.current;
    if (!scene) return undefined;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return undefined;

    const host = (scene.closest('.hero') as HTMLElement | null) || scene;

    const onMove = (event: PointerEvent) => {
      const rect = host.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
      const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
      scene.style.setProperty('--tilt-x', `${(y * -8).toFixed(2)}deg`);
      scene.style.setProperty('--tilt-y', `${(x * 10).toFixed(2)}deg`);
      scene.style.setProperty('--shift-x', `${(x * 18).toFixed(1)}px`);
      scene.style.setProperty('--shift-y', `${(y * 12).toFixed(1)}px`);
    };

    const onLeave = () => {
      scene.style.setProperty('--tilt-x', '0deg');
      scene.style.setProperty('--tilt-y', '0deg');
      scene.style.setProperty('--shift-x', '0px');
      scene.style.setProperty('--shift-y', '0px');
    };

    host.addEventListener('pointermove', onMove);
    host.addEventListener('pointerleave', onLeave);
    return () => {
      host.removeEventListener('pointermove', onMove);
      host.removeEventListener('pointerleave', onLeave);
    };
  }, []);

  return (
    <div className="hero-scene-3d" ref={sceneRef} aria-hidden="true">
      <div className="hero-scene-sky" />
      <div className="hero-scene-horizon" />
      <div className="hero-scene-stage">
        <div className="hero-scene-orb hero-scene-orb-a" />
        <div className="hero-scene-orb hero-scene-orb-b" />

        <div className="hero-ship">
          <div className="hero-ship-hull" />
          <div className="hero-ship-bridge" />
          <div className="hero-ship-stack" />
          <div className="hero-ship-wake" />
        </div>

        <div className="hero-container-stack">
          <div className="hero-box hero-box-back">
            <span />
            <span />
            <span />
          </div>
          <div className="hero-box hero-box-mid">
            <span />
            <span />
            <span />
          </div>
          <div className="hero-box hero-box-front">
            <span />
            <span />
            <span />
            <em>ALSHIRAA</em>
          </div>
        </div>

        <div className="hero-crane">
          <div className="hero-crane-mast" />
          <div className="hero-crane-arm" />
          <div className="hero-crane-cable" />
          <div className="hero-crane-hook" />
        </div>
      </div>
    </div>
  );
};

export default HeroScene3D;
